import { useContext, useEffect, useState } from "react";

import GlobalContext from "shared/providers/context/GlobalContext";

const useContextSettings = (context) => {
  const [cardType, setCardType] = useState("");
  const [itemRoute, setItemRoute] = useState("");
  const [contextClassName, setContextClassName] = useState(null);

  const { state } = useContext(GlobalContext);

  const tenantData = state.tenancy;
  const advancedThemeSettings = tenantData?.settings?.["advanced-theme"];

  useEffect(() => {
    switch (context) {
      case "course":
        setItemRoute(`/courses/`);
        setContextClassName("Vico068\\CourseTools\\Course");
        setCardType(advancedThemeSettings?.themeCourseThumbnails);
        break;

      case "media":
        setItemRoute(`/media/`);
        setContextClassName("App\\MediaSpaceContent");
        setCardType(advancedThemeSettings?.themeMediaSpaceThumbnails);
        break;

      case "blog":
        setItemRoute(`/blog/`);
        setContextClassName("App\\Blog");
        setCardType(advancedThemeSettings?.themeBlogThumbnails);
        break;

      case "social":
        setItemRoute(`/social/`);
        setContextClassName("App\\Social");
        setCardType(advancedThemeSettings?.themeBlogThumbnails);
        break;

      case "bundle":
        setItemRoute(`/bundles/`);
        setCardType(advancedThemeSettings?.themeBundleThumbnails);
        break;

      case "user":
        setItemRoute(`/user/`);
        setCardType(advancedThemeSettings?.themeUserThumbnails);
        break;

      case "user_text":
        setItemRoute(`/user/`);
        setCardType("image_with_title");
        break;

      case "category":
        setCardType(advancedThemeSettings?.themeCategoryThumbnails);
        setItemRoute(`/categories/`);
        break;

      case "groups":
        setCardType(advancedThemeSettings?.themeBlogThumbnails);
        setItemRoute(`/g/`);
        break;

      default:
        setCardType("image_only");
        break;
    }
  }, [context, advancedThemeSettings]);

  return { cardType, itemRoute, contextClassName };
};

export default useContextSettings;
